import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <section data-testid="not-found-page" className="min-h-[80vh] pt-32 pb-20 flex items-center">
      <div className="container-page text-center">
        <p className="overline mb-4">404</p>
        <h1 className="heading-1">This page is under construction.</h1>
        <p className="body-base mt-6 max-w-md mx-auto">The page you're looking for doesn't exist (or moved). Try one of these instead.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary">Go Home</Link>
          <Link to="/services" className="btn-secondary">Browse Services</Link>
          <Link to="/contact" className="btn-ghost">Contact us</Link>
        </div>
      </div>
    </section>
  );
}
